import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1c0bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "upload-curve" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "year flex-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Year", -1))
const _hoisted_6 = { class: "version flex-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Version", -1))
const _hoisted_8 = { class: "handler" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_11 = { class: "main" }
const _hoisted_12 = { class: "handler" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "download-button-wrapper" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "font_family icon-xiazai" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Download Template ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_year_picker = _resolveComponent("year-picker")!
  const _component_upload = _resolveComponent("upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, { dataSource: [
                {
                    name:
                        'Upload Curve Selection Of Restricted Cities Overview',
                },
            ] }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_a_select, {
              value: _ctx.year,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
              onChange: _ctx.handlerYearChange,
              placeholder: "Please select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearList, (year) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: year,
                    key: year
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(year), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_a_select, {
              value: _ctx.version,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.version) = $event)),
              disabled: !_ctx.year,
              placeholder: "Please select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionList, (version) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: version,
                    key: version
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(version), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.$btnPermissions('Local Curve Reset'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "reset-btn",
                  onClick: _ctx.handleReset
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('Local Curve Search'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  class: "search-btn",
                  onClick: _ctx.handleSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.$btnPermissions('Local Curve Upload'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                class: "btn upload-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUploadDrawer = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_button, { class: "btn export-btn" }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_table, {
            columns: _ctx.columns,
            dataSource: _ctx.data,
            rowKey: "id",
            bordered: "",
            pagination: false,
            rowClassName: 
                        (record, index) =>
                            index % 2 === 1 ? 'table-striped' : null
                    
          }, null, 8, ["columns", "dataSource", "rowClassName"])
        ])
      ])
    ]),
    _createVNode(_component_upload, {
      title: "Of Restricted Cities",
      visible: _ctx.showUploadDrawer,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showUploadDrawer) = $event)),
      onUpload: _ctx.handleUpload
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_year_picker, {
            value: _ctx.uploadYear,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.uploadYear) = $event)),
            allowClear: false
          }, null, 8, ["value"]),
          (_ctx.$btnPermissions('Local Curve Download'))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "downBtn",
                type: "primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)))
              }, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onUpload"])
  ], 64))
}